<template>
  <div class="upload_list sr-file" >
    <div
      class="upload_item"
      v-for="(tag, k) in uploadItem.fileList"
      v-show="k < (uploadItem.colNum || 3) || expand"
      :key="k"
    >
      <div @click="preview(tag)" style="display: inline-block;">
        <slot v-if="linkSlot" name="linkSlot"> </slot>
        <i v-else class="el-icon-link"></i>
      </div>

      <span class="upload_text" :title="tag.name">{{ tag.name }}</span>
      <div @click="preview(tag)" style="display: inline-block;">
        <slot v-if="viewSlot" name="viewSlot"> </slot>
        <i v-else class="el-icon-view"></i>
      </div>

      <i
        v-if="!isOff && offUpload"
        class="el-icon-close"
        @click="delFile(k)"
      ></i>
    </div>
  </div>
</template>


<!--
  功能：功能描述
  汪振涛
  时间：2020年11月27日 14:51:29
  版本：v1.0
-->
<script>
export default {
  name: "SrFile",
  inject: ["baseUrl", "imgBaseUrl"],
  data() {
    return {};
  },
  props: {
    uploadItem: {
      type: Object,
      default() {
        return {};
      },
    },
    expand: Boolean,
    isOff: Boolean,
    offUpload: {
      type: Boolean,
      default() {
        return true;
      },
    },
    linkSlot: {
      type: Boolean,
      default() {
        return false;
      },
    },
    viewSlot: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  mounted() {
    
  },
  methods: {
    preview(item) {
      if (["zip", "rar"].includes(item.name.split(".").pop())) {
        this.$utils.exportFile(
          `${this.baseUrl}/cqportalsite/api/file/download?id=${item.id}`
        );
      } else {
        window.open(`${this.imgBaseUrl}${item.id}`);
      }
    },
    delFile(k) {
      this.$emit("delFile", k);
    },
  },
};
</script>




// WEBPACK FOOTER //
// packages/SrFile/SrFile.vue